/* eslint-disable */
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { putData } from "utils/Gateway";

const LeadSubscribeConfirmBody = () => {
  const params = useParams();

  const [isConfirming, setIsConfirming] = useState(true);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  //function to confirm the lead's double opt-in subscription
  const confirmSubscribeHandler = async () => {
    try {
      setIsConfirming(true);

      let leadData = {
        leadid: params.id,
      };

      let requestUrl = url.API_BASE_URL + url.API_CONFIRM_LEAD_SUBSCRIBE;

      const response = await putData(requestUrl, leadData);

      if (response.status) {
        setIsConfirmed(true);
      } else {
        setErrorMessage(response.message || "Something went wrong");
      }
    } catch (error) {
      setErrorMessage(error.message);
    }

    setIsConfirming(false);
  };

  useEffect(() => {
    if (params.id) {
      confirmSubscribeHandler();
    }
  }, [params.id]);

  return (
    <div id="content_wrapper">
      <div className="authentication-wrapper login min-h-screen py-5 d-flex align-items-center justify-content-center">
        <div className="authentication-container px-4 py-5 mw-100 bg-white rounded-10 shadow-sm mx-auto text-center">
          {isConfirming ? (
            <div className="unsubdcribe-text">
              <h3 className="mb-3 fw-bold fs-xl">
                Confirmando tu suscripción...
              </h3>
            </div>
          ) : isConfirmed ? (
            <div className="unsubdcribe-text">
              <h3 className="mb-3 fw-bold fs-xl">¡Gracias!</h3>
              <p className="mb-0 text-gray fs-md">
                Tu suscripción ha sido confirmada correctamente.
              </p>
            </div>
          ) : (
            <div className="unsubdcribe-text">
              <h3 className="mb-3 fw-bold fs-xl">
                No se pudo confirmar la suscripción
              </h3>
              {errorMessage && (
                <p className="mb-0 text-gray fs-md">{errorMessage}</p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeadSubscribeConfirmBody;
